import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import {
  ControlsWrapper,
  StyledDragIndicator,
  StyledIconButton,
  StyledSecondaryAction
} from './ListItemSecondaryAction.styles';
import { ListItemSecondaryActionProps } from './ListItemSecondaryAction.types';

export const ListItemSecondaryAction = ({
  isMobile,
  isVisible,
  isOkko,
  isDragging,
  localOrder,
  brandId,
  moveUp,
  moveDown
}: ListItemSecondaryActionProps) => {
  const moveUpDisabled = localOrder.indexOf(brandId) === 0;
  const moveDownDisabled = localOrder.indexOf(brandId) === localOrder.length - 1;

  const handleMoveUp = () => {
    if (!moveUp) return;
    moveUp(brandId);
  };
  const handleMoveDown = () => {
    if (!moveDown) return;
    moveDown(brandId);
  };

  if (isMobile && isVisible && !isOkko) {
    return (
      <StyledSecondaryAction>
        <ControlsWrapper>
          <StyledIconButton size="small" onClick={handleMoveUp} disabled={moveUpDisabled}>
            <ArrowUpward fontSize="small" />
          </StyledIconButton>

          <StyledIconButton size="small" onClick={handleMoveDown} disabled={moveDownDisabled}>
            <ArrowDownward fontSize="small" />
          </StyledIconButton>
        </ControlsWrapper>
      </StyledSecondaryAction>
    );
  }

  return (
    <StyledSecondaryAction>
      <StyledDragIndicator isDragging={isDragging} isVisible={isVisible} isOkko={isOkko} isMobile={isMobile} />
    </StyledSecondaryAction>
  );
};
